import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import type { HTMLAttributes, JSX } from 'react';
import css from './ButtonSet.module.css';
export type ButtonSetProps = HTMLAttributes<HTMLDivElement>;
function ButtonSet(t0) {
  const $ = _c(8);
  let className;
  let divProps;
  if ($[0] !== t0) {
    ({
      className,
      ...divProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = divProps;
  } else {
    className = $[1];
    divProps = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = clsx(css.buttonSet, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== divProps || $[6] !== t1) {
    t2 = <div {...divProps} className={t1} />;
    $[5] = divProps;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
ButtonSet.displayName = 'DSButtonSet';
export default ButtonSet;